<template>
<div>
  <vs-table :data="value.parametersToCreate" :noDataText="$t('Decarbonization.EnergyScenarios.AllParametersDefined')" >
    <template slot="header">
      <h5 class="mt-4 mb-3">{{ $t('Decarbonization.EnergyScenarios.LOMParametersToCreate') }}</h5>
    </template>
    <template slot="thead">
      <vs-th>{{$t('Action')}}</vs-th>
      <vs-th>{{ $t('Decarbonization.EnergyScenarios.LOMName') }}</vs-th>
    </template>
    <template slot-scope="{data}">
      <tbody>
        <vs-tr v-for="parameter in data" :key="getParameterKey(parameter)">
          <vs-td width="100px" class="whitespace-no-wrap">
            <feather-icon
              icon="EditIcon"
              svgClasses="w-5 h-5 hover:text-primary stroke-current"
              @click.stop="openLOMEditionTab(parameter, createNew=true)"
              v-b-tooltip.hover :title="$t('Edit')"
            />
          </vs-td>
          <vs-td>
            <p class="font-medium truncate">{{ parameter.displayName }}</p>
          </vs-td>
        </vs-tr>
      </tbody>
    </template>
  </vs-table>
  <vs-table :data="value.parameters" :noDataText="$t('Decarbonization.EnergyScenarios.EmptyParametersDefined')">
    <template slot="header">
      <h5 class="mt-4 mb-3">{{ $t('Decarbonization.EnergyScenarios.LOMParametersCreated') }}</h5>
    </template>
    <template slot="thead">
      <vs-th>{{$t('Action')}}</vs-th>
      <vs-th>{{ $t('Decarbonization.EnergyScenarios.LOMName') }}</vs-th>
    </template>
    <template slot-scope="{data}">
      <tbody>
        <vs-tr v-for="parameter in data" :key="getParameterKey(parameter)">
          <vs-td width="100px" class="whitespace-no-wrap">
            <feather-icon
              icon="EditIcon"
              svgClasses="w-5 h-5 hover:text-primary stroke-current cursor-pointer"
              @click.stop="openLOMEditionTab(parameter, createNew=false)"
              v-b-tooltip.hover :title="$t('Edit')"
            />
          </vs-td>
          <vs-td>
            <p class="font-medium truncate">{{ parameter.displayName }}</p>
          </vs-td>
        </vs-tr>
      </tbody>
    </template>
  </vs-table>

</div>
</template>

<script>

import vSelect from 'vue-select';

import {
  FormLabel,
  ValidatedInput,
  ValidationMessage
} from "@/app/shared/components";

export default {
  /* eslint-disable vue/no-unused-components */
  components: {
    FormLabel,    
    vSelect,
    ValidatedInput,
    ValidationMessage
  },
  props: ['value'],
  emits: ['openLOMEditionTab'],
  data() {
    return {
    };
  },
  created() {
  },

  computed: {
  },

  methods: {
    getParameterKey(p) {
      return p.lomScenarioTypeId + "-" + p.lomVersionId + "-" + p.lomEntityId
    },
    openLOMEditionTab(parameter, createNew) {
      const obj = {};
      obj.parameter = parameter;
      obj.createNew = createNew;
      this.$emit('openLOMEditionTab', obj);
    }
  }
};
</script>